import {
  SendToNewsEmbed,
  SCRIPT_ID,
  loadSendToNewsScript,
  getSendToNewsScriptUrl,
} from "./SendToNewsEmbed";
import { HomeVideoPlacement } from "./HomeVideoPlacement";
import { StoryVideoWidget } from "./StoryVideoWidget";
export * from "./storyVideoOrchestrator";

export const VideoPlayer = HomeVideoPlacement;
export const FiVideoPlaceholder = HomeVideoPlacement;

export {
  SendToNewsEmbed,
  HomeVideoPlacement,
  StoryVideoWidget,
  SCRIPT_ID,
  loadSendToNewsScript,
  getSendToNewsScriptUrl,
};

export default VideoPlayer;

